export default __webpack_public_path__ + "5e26cf9411ace51c88f111884a98448a.png";